module.exports = __webpack_public_path__ + "img/syukyaku-landing-pa006.9d147816.png";